module.exports = "<h5>{{'services.activations.orderAndPay.title' | translate}}</h5>\n<p>{{ 'services.activations.order.info' | translate }}</p>\n\n<nav class=\"nav-tabs\" style=\"margin-top:16px\">\n    <ul>\n      <li><a ui-sref=\"services.orderAndPay.main\" ui-sref-active=\"active\" ui-sref-active-eq class=\"icon-home\">Info base</a></li>\n      <li><a ui-sref=\"services.orderAndPay.pickupPoint\" ui-sref-active=\"active\" ui-sref-active-eq class=\"icon-menu\">Punti di ritiro</a></li>\n    </ul>\n  </nav>\n  \n  <div class=\"nav-tabs-contents\">\n    <div class=\"page-content\" ui-view></div>\n  </div>\n  ";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/services/orderAndPay/orderAndPay.html
 ** module id = 503
 ** module chunks = 0
 **/